import {
    ApiMessage,
    MessageCase,
    MessageStatus,
    MessageTextType,
    MessageType,
    SendInternalMessageRequest,
    SendMessageRequest
} from "../../models/Dialogs/message"

export const convertRequestToResponse = (
    message: SendMessageRequest | SendInternalMessageRequest,
    operatorId: string,
    messageId: string,
    status?: MessageStatus,
    isInternal = false,
    dialogId?: string
): ApiMessage => {
    return {
        Case: MessageCase.Message,
        Fields: {
            ...message,
            Actions: message.Actions ?? [],
            Id: messageId,
            MessageType: isInternal ? MessageType.InternalOperatorMessage : MessageType.Message,
            TextType: MessageTextType.Markdown,
            Direction: 1,
            Sender: { Id: operatorId },
            DialogId: dialogId ?? "",
            AddedDate: Date.now(),
            Context: [[]],
            Status: status ?? 0
        }
    }
}
